import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useApp } from '../../context/AppContext.jsx'
import { pjDeleteProject, pjGetProject } from '../../db/api.js'
import ProjectMenu from './ProjectMenu.jsx'
import EditProjectModal from './EditProjectModal.jsx'
import SaveAsTemplateModal from './SaveAsTemplateModal.jsx'
import ProjectStagesModal from './ProjectStagesModal.jsx'

// Overview rows contain only summaries; fetch the full project before editing
// so fields such as description are preserved when the form is saved.
export default function OperationProjectMenu({ project, onChanged, onDeleted }) {
  const { confirm, toast, selectedClient } = useApp()
  const [action, setAction] = useState(null)
  const [details, setDetails] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!action) return
    let active = true
    pjGetProject(project.id).then(value => {
      if (active) setDetails(value)
    }).catch(e => { if (active) setError(e.message) })
    return () => { active = false }
  }, [action, project.id, selectedClient?.id])

  const begin = next => { setDetails(null); setError(null); setAction(next) }
  const close = () => setAction(null)
  const remove = async () => {
    const ok = await confirm({
      title: 'Excluir projeto',
      message: `Excluir o projeto "${project.nome || project.titulo}"? As tarefas vinculadas também serão removidas.`,
      confirmText: 'Excluir projeto', danger: true,
    })
    if (!ok) return
    try {
      await pjDeleteProject(project.id)
      toast('Projeto excluído.', 'success')
      onDeleted?.()
    } catch (e) { toast(`Erro ao excluir: ${e.message}`, 'error') }
  }

  if (project.is_delete) return null
  return <div className="op-project-menu">
    <ProjectMenu portal title={`Configurações do projeto ${project.nome || project.titulo}`}
      onEdit={() => begin('edit')} onStages={() => begin('stages')} onSaveTemplate={() => begin('template')} onDelete={remove} />
    {action && createPortal(<div onClick={e => e.stopPropagation()} onKeyDown={e => { if (e.key === 'Escape' && action !== 'stages') { e.stopPropagation(); close() } }}>
      {details ? action === 'edit'
        ? <EditProjectModal project={details} onClose={close} onSaved={updated => { close(); onChanged?.(updated) }} />
        : action === 'stages' ? <ProjectStagesModal key={details.id} project={details} onClose={close} onChanged={() => onChanged?.(details)} />
        : <SaveAsTemplateModal project={details} onClose={close} onSaved={close} />
        : <div className="op-project-settings-overlay" onMouseDown={close}>
          <div className="op-project-settings-loading" role="dialog" aria-label="Configurações do projeto" onMouseDown={e => e.stopPropagation()}>
            <p role={error ? 'alert' : 'status'}>{error || 'Carregando projeto…'}</p>
            <button type="button" className="od-btn" autoFocus onClick={close}>Fechar</button>
          </div>
        </div>}
    </div>, document.body)}
  </div>
}
